import { ChangeEvent, Component } from 'react';
import { Navigate } from 'react-router-dom';

import { 
  Typography,
  Box,
  Grid,
  Stack,
  Paper,
  Button,
} from '@mui/material';
import { 
  styled,
} from '@mui/material/styles';

import { 
  Logout,
  MailOutlined,
  PrivacyTipOutlined,
  VerifiedUserOutlined,
  AccessTime,
  AccountBalanceWalletOutlined,
  EmojiEventsOutlined,
} from '@mui/icons-material';

import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { OtpInput } from 'reactjs-otp-input';

import { Trans, withTranslation } from 'react-i18next';
import i18n from '../assets/locales';

import Layout from '../layouts/layout.component';

import AuthService from '../services/auth.service';
import UserService from '../services/user.service';
import WalletService from '../services/wallet.service';
import CouponService from '../services/coupon.service';

import { IUser } from '../models/user.model';


interface Coupon {
  serialNumber: string;
  credit: number;
  updatedAt: string;
};

type Props = {
}

type State = {
  redirect: string | null,
  userReady: boolean,
  loading: boolean,
  targetUser: IUser | null,
  user: IUser,
  userEmoji: string,
  credits: number,
  points: number,
  roles: string,
  coupons: Coupon[],
  couponId: string,
  couponMessage: string,
  terminalId: string,
  remoteLoginMessage: string,
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: 'transparent',
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  // textAlign: 'center',
  color: 'white',
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


class Profile extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.handleChangeCouponId = this.handleChangeCouponId.bind(this);
    this.handleRegisterCoupon = this.handleRegisterCoupon.bind(this);
    this.handleChangeTerminalId = this.handleChangeTerminalId.bind(this);
    this.handleSigninRemote = this.handleSigninRemote.bind(this);
    this.handleSignout = this.handleSignout.bind(this);

    this.state = {
      redirect: null,
      userReady: false,
      loading: false,
      targetUser: null,
      user: {},
      userEmoji: 'Mystery',
      credits: 0,
      points: 0,
      roles: '',
      coupons: [],
      couponId: '',
      couponMessage: '',
      terminalId: '',
      remoteLoginMessage: '',
    };
  }

  componentDidMount() {
    const uuid = localStorage.getItem('sub') as string;
    const accessToken = localStorage.getItem('accessToken') as string;

    if (!uuid || !accessToken) this.setState({ redirect: '/signin' });

    UserService.getUser(uuid).then(
      (res) => {
        const user = res.data;
        // console.log(`user: ${JSON.stringify(user, null, 2)}`);

        this.setState({
          userReady: true,
          user: user,
        });

        // console.log(`user: ${user.username} [${user.uuid}], accessToken: ${accessToken}`);
        // console.log(`verified: ${user.verified}, roles: ${user.roles}`);

        UserService.getProfile(user.uuid!).then(
          (res) => {
            // console.log(`res: ${JSON.stringify(res, null, 2)}`);
            const profile = res.data;
            // console.log(`profile: ${JSON.stringify(profile, null, 2)}`);
            
            this.setState({
              userEmoji: profile?.emoji || 'Mystery',
            });
          },
          (err) => {
            console.log(`getProfile error: ${JSON.stringify(err, null, 2)}`);
          }
        );

        WalletService.getWallets(user.uuid!).then(
          (res) => {
            // console.log(`res: ${JSON.stringify(res, null, 2)}`);
            const wallets = res.data.wallets;
            // console.log(`wallets: ${JSON.stringify(wallets, null, 2)}`);

            let credits = 0;
            let points = 0;
            let coupons: Coupon[] = [];

            for (let wallet of wallets || []) {
              // console.log(`wallet: ${JSON.stringify(wallet, null, 2)}`);
              // console.log(`type: ${wallet.type}, balance: ${wallet.balance} [${typeof wallet.balance}]`);
              if (wallet.type?.toLowerCase() === "credit") {
                credits += wallet.balance ?? 0;
              } else if (wallet.type?.toLowerCase() === "point") {
                points += wallet.balance ?? 0;
              }

              // console.log(`wallet.coupons: ${JSON.stringify(wallet.coupons, null, 2)}`);
              if (wallet.coupons) {
                wallet.coupons.forEach((coupon: Coupon, idx: any) => {
                  coupons.push({
                    serialNumber: coupon.serialNumber,
                    credit: coupon.credit,
                    updatedAt: new Date(coupon.updatedAt).toLocaleString(),
                  });
                });
              }

              // console.log(`credits: ${credits}, points: ${points}`);
              // console.log(`coupons: ${JSON.stringify(coupons, null, 2)}`);
            }

            // console.log(`credits: ${credits}, points: ${points}`);
            // console.log(`coupons: ${JSON.stringify(coupons, null, 2)}`);
            
            this.setState({
              credits: credits,
              points: points,
              coupons: coupons,
            });

            // console.log(`this.state: ${JSON.stringify(this.state, null, 2)}`);
          },
          (err) => {
            console.log(`Something went wrong: ${err.response.status}`);
            if (err.response && err.response.status === 401) {
              AuthService.signout(user.uuid!);
              this.setState({ redirect: "/signin" });
            }
          }
        );
      },
      (err) => {
        console.log(`Something went wrong: ${err.response.status}`);
        if (err.response && err.response.status === 401) {
          AuthService.signout(uuid);
          this.setState({ 
            redirect: "/signin" 
          });
        }
      }
    );
  }

  componentWillUnmount() {
    window.location.reload();
  }

  handleSignout() {
    let user = this.state.user;

    AuthService.signout(user.uuid!);

    this.setState({
      redirect: '/signin'
    }); 
  }

  validationCouponId() {
    // console.log(`validationCouponId`);
    return Yup.object().shape({
      couponId: Yup
        .string()
        .length(19, "Coupon Serial Number must be formatted as '####-####-####-####'")
        .min(19, "Coupon Serial Number must be formatted as '####-####-####-####'")
        .max(19, "Coupon Serial Number must be formatted as '####-####-####-####'")
        .required("You must input the coupon ID"),
    });
  }

  handleChangeCouponId(e: ChangeEvent<HTMLInputElement>) {
    // console.log(`formValue    : ${e.target.value}`);
    let couponId: string = e.target.value;

    // console.log(`couponId    : ${couponId}`);
    couponId = couponId.toUpperCase();
    couponId = couponId.split('-').join('');
    if (couponId.length > 0) {
      couponId = couponId.match(new RegExp('.{1,4}','g'))?.join('-') ?? "";
    }

    // console.log(`couponId    : ${couponId}`);
    e.target.value = couponId;
    // this.setState({
    //   ...this.state,
    //   couponId: couponId,
    // });
    // console.log(`this: ${JSON.stringify(this.state)}`);
  }

  handleRegisterCoupon(formValue: { couponId: string;}) {
    const username = this.state.user.username;
    const userUuid = this.state.user.uuid;

    const { couponId } = formValue;

    // console.log(`handleRegisterCoupon`);
    // console.log(`username    : ${username}`);
    // console.log(`userUuid    : ${userUuid}`);
    // console.log(`couponId    : ${couponId}`);

    this.setState({
      couponMessage: "",
      loading: true
    });

    CouponService.registerCoupon(userUuid!, couponId!)
      .then((res) => {
        // console.log(`OK: ${JSON.stringify(res, null, 2)}`)

        this.setState({
          ...this.state,
          couponMessage: 'Coupon has been successfully registered',
        })

        WalletService.getWallets(userUuid!).then(
          (res) => {
            // console.log(`getWallets: ${JSON.stringify(res, null, 2)}`);
            const wallets = res.data.wallets;

            let credits = 0;
            let points = 0;

            for (let wallet of wallets || []) {
              // console.log(`wallet: ${JSON.stringify(wallet, null, 2)}`);
              // console.log(`type: ${wallet.type}, balance: ${wallet.balance} [${typeof wallet.balance}]`);
              if (wallet.type?.toLowerCase() === "credit") {
                credits += wallet.balance ?? 0;
              } else if (wallet.type?.toLowerCase() === "point") {
                points += wallet.balance ?? 0;
              }
              // console.log(`credits: ${credits}, points: ${points}`);
            }

            // console.log(`credits: ${credits}, points: ${points}`);
            
            this.setState({
              ...this.state,
              credits: credits,
              points: points,
              loading: false,
            }, () => {  
              // console.log(`this.state: ${JSON.stringify(this.state, null, 2)}`);
            });
          },
          (err) => {
            console.log(`getWallets error: ${JSON.stringify(err, null, 2)}`);
          }
        );
      })
      .catch((err) => {
        console.log(`FAIL: ${JSON.stringify(err, null, 2)}`);
        this.setState({
          loading: false,
          couponMessage: err.message,
        });
      });
  }

  handleChangeTerminalId(value: string) {
    this.setState({
      ...this.state,
      terminalId: value
    });
    // console.log(`this: ${JSON.stringify(this.state)}`);
  }

  handleSigninRemote() {
    const username = this.state.user.username;
    const accessToken = localStorage.getItem('accessToken') as string;
    const terminalId = this.state.terminalId;

    // console.log(`handleRemoteSignin`);
    // console.log(`username    : ${username}`);
    // console.log(`accessToken : ${accessToken}`);
    // console.log(`terminalId  : ${terminalId}`);

    this.setState({
      loading: true
    });

    AuthService.remoteSignIn(username!, accessToken!, terminalId); 
    
    // AuthService.remoteSignin(username!, accessToken, terminalId).then(
    //   (resp) => {

    //   },
    //   error => {

    //   }
    // );

    this.setState({
      loading: false
    });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to = { this.state.redirect } />
    }

    // console.log(`this.state: ${JSON.stringify(this.state, null, 2)}`);

    const {
      loading,
      user,
      userEmoji,
      couponMessage,
      coupons,
      terminalId,
      remoteLoginMessage
    } = this.state;

    const initialValues = {
      couponId: "",
      terminalId: "",
    };

    return (
      <Layout>
        <div className="container mt-5">
          {(this.state.userReady) ? (
              <div className='container col-md-12'>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                  <Box display='flex' justifyContent='flex-start' alignItems='center'>
                    <Stack>
                      <Item>
                        <h2 className='display-5'>
                          {/* Profile of [<strong>{user.username}</strong>] */}
                          <Trans>{i18n.t('profile:description', {
                            username: `<strong>${user.username}</strong>`,
                            interpolation: { escapeValue: false },
                            })}</Trans>
                        </h2>
                      </Item>
                      <Item>
                        <p> { i18n.t('profile:credit') } <strong style={{fontSize:'1.15rem', color:'white', backgroundColor:'#rgba(0, 0, 0, 0.5)' }}> { this.state.credits } </strong> </p>
                      </Item>
                    </Stack>
                  </Box>
                  <Box display='flex' justifyContent='flex-end' alignItems='center'>
                    <Button startIcon={<Logout />} color='secondary' onClick={this.handleSignout}>
                      <Trans>{ i18n.t('profile:signout') }</Trans>
                    </Button>
                  </Box>
                </Box>
                <Box sx={{ height: 10 }}></Box>

                <div className='container'>
                  <div className='row'>
                    <div className='col col-md6'>
                      <Box className='card card-container' 
                          style={{ background: 'transparent' }}
                          sx={{ border: 1, borderColor: '#rgba(255, 255, 255, 0.9)', borderRadius: '8px' }}>
                        <Stack>
                          <Box display='flex' justifyContent='justify' alignItems='center' sx={{ mb: 3 }}>
                            <Box justifyContent='flex-start' alignItems='center'>
                              <img src={ require(`../assets/images/avatars/${userEmoji}.png`) } alt='profile-img' className='profile-img-card' />
                              <p><MailOutlined /> { user.email } { (user.verified) ? <VerifiedUserOutlined sx={{ color: '#rgba(0, 0, 255, 0.8)', fontSize: 14 }} />:<PrivacyTipOutlined sx={{ color: '#rgba(128, 128, 128, 0.8)', fontSize: 14 }} /> } </p>
                            </Box>
                            <Box justifyContent='flex-end' alignItems='center' sx={{ ml: 5 }}>
                              <Stack>
                                <Box sx={{ flexGrow: 1 }}>
                                  <Grid container spacing={2}>
                                    <Grid size={9}>
                                      <Typography variant='subtitle1'>Ranking</Typography>
                                    </Grid>
                                    <Grid size={3}>
                                      <Typography variant='subtitle1'>#</Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                                <Box sx={{ flexGrow: 1 }}>
                                  <Grid container spacing={2}>
                                    <Grid size={9}>
                                      <Typography variant='subtitle1'>Yealry</Typography>
                                    </Grid>
                                    <Grid size={3}>
                                      <Typography variant='subtitle1'>#</Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                                <Box sx={{ flexGrow: 1 }}>
                                  <Grid container spacing={2}>
                                    <Grid size={9}>
                                      <Typography variant='subtitle1'>Monthly</Typography>
                                    </Grid>
                                    <Grid size={3}>
                                      <Typography variant='subtitle1'>#</Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Stack>
                            </Box>
                          </Box>
                          <Box display='flex' justifyContent='justify' alignItems='center' sx={{ mb: 3 }}>
                            <Stack direction='row' spacing={1} sx={{ width: '100%' }} justifyContent='space-around' alignItems='center'>
                              <Box>
                                <Stack direction='column' spacing={1} alignItems='center'>
                                  <AccessTime />
                                  <Typography><strong>-- : --</strong></Typography>
                                  <Typography sx={{ fontSize: '0.8rem' }}>{ i18n.t('profile:hoursPlayed') }</Typography>
                                </Stack>
                              </Box>
                              <Box>
                                <Stack direction='column' spacing={1} alignItems='center'>
                                  <AccountBalanceWalletOutlined />
                                  <Typography><strong>{ this.state.credits }</strong></Typography>
                                  <Typography sx={{ fontSize: '0.8rem' }}>{ i18n.t('profile:creditsOwned') }</Typography>
                                </Stack>
                              </Box>
                              <Box>
                                <Stack direction='column' spacing={1} alignItems='center'>
                                  <EmojiEventsOutlined />
                                  <Typography><strong>{ this.state.points }</strong></Typography>
                                  <Typography sx={{ fontSize: '0.8rem' }}>{ i18n.t('profile:pointsEarned') }</Typography>
                                </Stack>
                              </Box>
                            </Stack>
                          </Box>
                        </Stack>
                      </Box>
                    </div>
                    <div className='col col-md6'>
                      <div className='container'>
                        <div className='row'>
                          <div className='col'>
                            <Box className='card card-container' 
                                style={{ background: 'transparent' }}
                                sx={{ border: 1, borderColor: '#rgba(255, 255, 255, 0.9)', borderRadius: '4px' }}>
                              <Formik initialValues={initialValues} validationSchema={this.validationCouponId} onSubmit={this.handleRegisterCoupon}>
                                <Form>
                                  <div className="form-group mb-2">
                                    <label htmlFor="couponId" style={{color: "#ffffff", margin: "0 0 5px 0"}}><strong>{i18n.t('profile:claimWelcomeCoupon')}</strong></label>
                                    <Field 
                                      name="couponId" 
                                      type="text"
                                      className="form-control"
                                      placeholder="####-####-####-####"
                                      onKeyUp={this.handleChangeCouponId} />
                                    {/* <Field name="couponId" type="text" className="form-control" placeholder="####-####-####-####" /> */}
                                    <ErrorMessage 
                                      name="couponId"
                                      component="div" 
                                      render={ msg => <span style={{ color: 'rgb(255, 0, 0)' }}>{msg}</span> } />
                                  </div>

                                  <div className="form-group mt-3">
                                    <button type="submit" className="btn btn-primary btn-block w-100" disabled={loading}>
                                      {loading && (<span className="spinner-border spinner-border-sm mr=3"></span> )}
                                      <span>{ i18n.t('profile:register_coupon') }</span>
                                    </button>
                                  </div>

                                  {couponMessage && (
                                    <div className="form-group">
                                      <div className="alert alert-danger" role="alert">
                                        { couponMessage }
                                      </div>
                                    </div>
                                  )}
                                </Form>
                              </Formik>
                            </Box>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col'>
                            <Box className='card card-container'
                              style={{ background: 'transparent' }}
                              sx={{ border: 1, borderColor: '#rgba(255, 255, 255, 0.9)', borderRadius: '4px' }}>
                                { i18n.t('profile:registerdCoupons') }
                              <div className='row' style={{ height: '12px' }}>
                                <div className='col' />
                              </div>
                                { coupons && (
                                  coupons.map((coupon, idx) => (
                                    <div className='container' key={idx}>
                                      <div className='row'>
                                        <div className='col' style={{ fontSize: '9pt' }}><span>{ coupon.serialNumber ?? ''}</span></div>
                                        <div className='col text-end' style={{ fontSize: '9pt' }}>
                                          <span>{ coupon.updatedAt ?? ''}</span>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                )}
                            </Box>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {
                /* 
                <br />

                <div className="card card-container">
                  <div style={{color: "#000000"}}>
                    <h3><strong>Remote Signin</strong></h3>
                  </div>
                  <OtpInput
                    numInputs={6}
                    value={terminalId}
                    onChange={(value) => {this.handleChangeTerminalId(value)}}
                    containerStyle={"outlined"}
                    inputStyle={{
                      width: '32px',
                      height: '32px',
                      margin: '0 2px',
                    }}
                    separator={<span> </span>}
                    />
                  <br />
                  <button type="submit" className="btn btn-primary btn-block w-100" onClick={this.handleSigninRemote}>
                    <span>Signin on Terminal</span>
                  </button>
                </div> 
                */
                }
              </div> 
            ) : (
              null
            )}
        </div>
      </Layout>
    );
  }
}

export default withTranslation()(Profile)
